import {
  AllocationsApi,
  AllocationsApiAllocationsDangerousGoodsValidationRequest,
  AllocationsApiAllocationsCreateInternalMoveManualRequest,
  CreateManualAllocationDto,
  AllocationsApiAllocationsPrePlanningValidationRequest,
  YardBlockSlotOccupanciesApi,
  CreateYardReservationDto,
  YardPositionDto,
} from '@storage/app/api'
import { createApiClient } from '@storage/app/http-client'

export class ContainerPlanningService {
  public async createReservation(
    createYardReservationDto: CreateYardReservationDto,
  ): Promise<void> {
    await createApiClient(YardBlockSlotOccupanciesApi).yardBlockSlotOccupanciesCreateReservation({
      createYardReservationDto,
    })
  }

  public async createAllocationForSingleTurnover(
    createManualAllocationDto: CreateManualAllocationDto,
  ): Promise<void> {
    await createApiClient(AllocationsApi).allocationsCreateManualForSingleTurnover({
      createManualAllocationDto,
    })
  }

  public async createAllocation(createManualAllocationDto: CreateManualAllocationDto) {
    await createApiClient(AllocationsApi).allocationsCreateManual({
      createManualAllocationDto,
    })
  }

  public async prePlanningValidation(
    allocationsPrePlanningValidationRequest: AllocationsApiAllocationsPrePlanningValidationRequest,
  ) {
    await createApiClient(AllocationsApi).allocationsPrePlanningValidation(
      allocationsPrePlanningValidationRequest,
    )
  }

  public async dangerousGoodsPrePlanningValidation(
    allocationsDangerousGoodsValidationRequest: AllocationsApiAllocationsDangerousGoodsValidationRequest,
  ) {
    await createApiClient(AllocationsApi).allocationsDangerousGoodsValidation(
      allocationsDangerousGoodsValidationRequest,
    )
  }
  public async updateContainerPosition(containerTurnoverId: string, location: YardPositionDto) {
    await createApiClient(YardBlockSlotOccupanciesApi).yardBlockSlotOccupanciesUpdateContainerPosition({
      createYardPositionDto: {
        containerTurnoverId,
        location,
      },
    })
  }

  public async createInternalMoveManual(
    allocationsCreateInternalMoveManualRequest: AllocationsApiAllocationsCreateInternalMoveManualRequest,
  ) {
    const { data } = await createApiClient(AllocationsApi).allocationsCreateInternalMoveManual(
      allocationsCreateInternalMoveManualRequest,
    )

    return data
  }
}
